export default "__VITE_ASSET__DTJrRreZ__"